
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/smart_scroll/templates/layout"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='smartScrollComponent-stickyHeader'>\n  <time class='streamComponent-activityHeader streamComponent-activityHeader--group sticky_header--over'></time>\n</div>\n<div class='smartScrollComponent-notificationRegion'></div>\n<div class='scrollbar-container'>\n  <div class='smartScrollComponent-pastLoaderRegion'></div>\n  <div class='scrollbar-contentWrapper' role='group'></div>\n  <div class='smartScrollComponent-futureLoaderRegion'></div>\n</div>\n";
},"useData":true});
    }).call(this);
  